module.exports = __webpack_public_path__ + "593a3d53/img/comment-question-icon.7dd26e04.svg";